import { useEffect, useRef } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { trackEvent } from "~/utils/analytics";

export const useTrackPageVisit = (
  eventName: string,
  { skip = false }: { skip?: boolean } = {}
) => {
  const { data: userInfo } = useGetCurrentUser();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (skip || !userInfo?.email) {
      return;
    }
    if (!hasTracked.current) {
      trackEvent({ eventName });
      hasTracked.current = true;
    }
  }, [eventName, userInfo, skip]);
};
